var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisualCustomizer = function SvgVisualCustomizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 41",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.5,
    y: 0.729,
    fill: "#53F5FF",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.5,
    y: 0.729,
    fill: "url(#visual-customizer_svg__a)",
    fillOpacity: 0.6,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    d: "M11.592 13.584H8.176l5.021 14.546h3.963l5.014-14.546h-3.409l-3.523 11.051h-.134zM27.547 28.343c2.905 0 4.73-1.705 4.872-4.212h-2.855c-.177 1.165-.944 1.818-1.981 1.818-1.414 0-2.33-1.186-2.33-3.274 0-2.06.924-3.239 2.33-3.239 1.108 0 1.818.732 1.981 1.819h2.855c-.127-2.522-2.038-4.177-4.886-4.177-3.31 0-5.355 2.294-5.355 5.64 0 3.316 2.01 5.625 5.37 5.625"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual-customizer_svg__a",
    x1: 30,
    x2: 4.5,
    y1: 38.23,
    y2: 8.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0055FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF",
    stopOpacity: 0
  })))));
};
export default SvgVisualCustomizer;